import { SplashV2 } from '../components';

export default function SplashTestPage() {

  return <SplashV2
    onComplete={() => {
      console.log('animation complete')
    }}
    introDelay={5000}
    fallbackTimeout={8000}
  />;

}
